import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ImageComponent } from '@/components/Image';

import { ScStepCard } from './styled';

export interface StepCardProps {
  image: string;
  title: string;
  text?: string;
}

export const StepCard: FC<StepCardProps> = ({ title, text, image }) => {
  const { t } = useTranslation('jackpot');

  return (
    <ScStepCard>
      <div className="title">{t(title)}</div>
      {text && <div className="text">{t(text)}</div>}
      <ImageComponent
        src={image}
        alt="step image"
        className="step-image"
        height={128}
        width={84}
      />
    </ScStepCard>
  );
};
